import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bdfbea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800"
}
const _hoisted_2 = {
  key: 0,
  class: "pl-0.5 text-orange-600"
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(` relative mt-1 flex w-full flex-col justify-center`)
}
const _hoisted_4 = ["disabled", "placeholder", "type", "value"]
const _hoisted_5 = {
  key: 1,
  class: "error-message text-sm text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.noPadding ? 'py-0' : 'py-3'} w-full ${
      _ctx.isLabelInFrontInput && 'mb-1 flex items-center space-x-2'
    }`)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: "input",
        class: _normalizeClass(`w-full border p-2 leading-normal ${
          _ctx.isError ? 'border-error' : 'border-[#dee1e3]'
        } relative appearance-none bg-white text-left font-sans text-dark shadow-sm outline-none  focus:border-primary`),
        disabled: _ctx.disabled ? _ctx.disabled : false,
        placeholder: _ctx.placeholder,
        type: _ctx.type ? _ctx.type : 'text',
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)
        ))
      }, null, 42, _hoisted_4)
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}